import enStrings from "../locales/client/en.json"
import esStrings from "../locales/client/es.json"
import deStrings from "../locales/client/de.json"
import frStrings from "../locales/client/fr.json"

import enDashboardStrings from "../locales/dashboard/en.json"
import huDashboardStrings from "../locales/dashboard/hu.json"

export const CLIENT_LOCALES = {
    en: "en",
    es: "es",
    de: "de",
    fr: "fr",
}

export const DASHBOARD_LOCALES = {
    en: "en",
    hu: "hu",
}

export const CLIENT_LOCALE_STRINGS = {
    [CLIENT_LOCALES.en]: enStrings,
    [CLIENT_LOCALES.es]: esStrings,
    [CLIENT_LOCALES.de]: deStrings,
    [CLIENT_LOCALES.fr]: frStrings,
}

export const DASHBOARD_LOCALE_STRINGS = {
    [DASHBOARD_LOCALES.en]: enDashboardStrings,
    [DASHBOARD_LOCALES.hu]: huDashboardStrings,
}

